import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import swal from 'sweetalert'
import { Button, FormControl, OverlayTrigger, Popover } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import CitationEditor from './CitationEditor'
import { updatePublication } from '../reducers/managePublications'

class PublicationOverviewField extends Component {

  state = {
    editMode: false,
    editableText: this.props.text || "",
    editableArray: this.props.array || [],
    file: null,
  }


  toggleEditMode = () => {
    this.setState({ editMode: !this.state.editMode })
  }


  handleChangeEditableText = (e) => {
    this.setState({ editableText: e.target.value })
  }

  handleChangeEditableCitation = (e) => {
    this.setState({ editableText: e })
  }

  handleChangeEditableArray = (values) => {
    this.setState({ editableArray: values })
  }


  handleChangeFile = (e) => {
    this.setState({ file: e.target.files[0] })
  }


  handleCancel = () => {
    this.setState({
      editMode: false,
      editableText: this.props.text,
      editableArray: this.props.array || []
    })
  }

  handleSave = () => {
    const { fieldName } = this.props

    if ((fieldName === 'citation' || fieldName === 'year') && !this.state.editableText) {
      const name = `${fieldName[0].toUpperCase()}${fieldName.slice(1)}`
      return swal({
        title: "Error",
        text: `${name} cannot be blank`,
        icon: "error",
        button: "Continue",
      })
    } else if (fieldName === 'therapeutic_areas' && !this.state.editableArray.length) {
      return swal({
        title: "Error",
        text: `Therapeutic Area(s) cannot be blank`,
        icon: "error",
        button: "Continue",
      })
    }

    this.setState({ editMode: false }, () => {
      if (this.props.array) {
        this.props.editPublication(fieldName, this.state.editableArray)
      } else if (fieldName === 'document') {
        this.props.editPublication(this.props.fieldName, this.state.file)
      } else {
        this.props.editPublication(fieldName, this.state.editableText.replace(/(?:\\[rn]|[\r\n])\s+/g, " ").trim())
      }
    })
  }

  renderDisplayText = () => {
    const { fieldName, text } = this.props

    if ((fieldName === 'publication_url' || fieldName === 'document') && text && text.length > 0) {
      return (
        <a href={text} target="_blank" rel="noopener noreferrer">
          <span className='publication-url'>
            Click here
          </span>
        </a>
      )
    } else if (fieldName === 'publication_url' || fieldName === 'document') {
      return <span></span>
    } else if (fieldName === 'citation') {
      return <span dangerouslySetInnerHTML={{__html: text}}></span>
    } else {  
      return (
        <span>
          {text}
        </span>
      )
    }
  }

  renderEditField = () => {
    const { options, fieldName, labelKey, allowMultipleSelections } = this.props
    const { editableText, editableArray } = this.state

    if (this.props.array) {
      return (
        <Typeahead
          id={`edit-${fieldName}-typeahead`}
          clearButton
          labelKey={labelKey}
          allowNew={!!this.props.allowNew}
          multiple={allowMultipleSelections}
          selected={editableArray}
          options={options}
          placeholder={`Enter ${fieldName.split("_").join(' ')}`}
          onChange={this.handleChangeEditableArray}
        />
      )
    } else if (this.props.fieldName === 'document') {
      return (
        <input
          type="file"
          name="file"
          onChange={this.handleChangeFile}
        />
      )
    } else if (this.props.fieldName === 'month') {
      const months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

      const monthOptions = [
        <option key='no-month-selected' value="">-</option>,
        ...months.map(month => <option key={month} value={month}>{month}</option>)
      ]

      return (
        <FormControl
          value={editableText}
          onChange={this.handleChangeEditableText}
          componentClass="select"
        >
          {monthOptions}
        </FormControl>
      )
    } else if (fieldName === 'done_with_genesis' || fieldName === 'regulatory_related') {
      const choices = ['Yes', 'No']

      const yesNoOptions = [
        <option key='empty-choice-option' value="">-</option>,
        ...choices.map(choice => <option key={choice} value={choice}>{choice}</option>)
      ]

      return (
        <FormControl
          componentClass='select'
          name={fieldName}
          value={editableText}
          onChange={this.handleChangeEditableText}
        >
          {yesNoOptions}
        </ FormControl>
      )
    } else if (fieldName === 'citation') {
      return (
        <CitationEditor
          citation={editableText}
          handleChange={this.handleChangeEditableCitation}
        />
      )
    } else {
      return (
        <FormControl
          value={editableText}
          onChange={this.handleChangeEditableText}
        />
      )
    }
  }

  render() {
    const { publication, currentUser } = this.props

    const emptyDocumentPopover = (
      <Popover id="empty-document-popover" title="Delete Document?">
        <p>
          Saving an empty document will <strong>delete the current document.</strong>
        </p>
        <br/>
        <p>
          Are you sure you want to proceed? <strong>This action is irreversible.</strong>
        </p>
        <br/>
        <center>
        <Button
          bsStyle='danger'
          style={{marginRight: '5px'}}
          onClick={this.handleSave}
        >
          Delete Document
        </Button>
        <Button
          style={{marginLeft: '5px'}}
          onClick={this.handleCancel}
        >
          Cancel
        </Button>
        </center>
      </Popover>
    )

    return (
      <Fragment>
        <td style={{width: '100%'}}>
          {this.state.editMode && currentUser ?
          // {this.state.editMode && currentUser && currentUser.is_manager ?
            this.renderEditField()
            :
            this.renderDisplayText()
          }
        </td>
        <td>
          <div className="OverviewField">
            {this.state.editMode ?
              <span style={{float:"right"}}>
                {publication && publication.document && !this.state.file && this.props.fieldName === "document" ?
                  <OverlayTrigger
                    trigger="click"
                    placement="top"
                    overlay={emptyDocumentPopover}
                  >
                    <Button className="edit-icon">
                      Save
                    </Button>
                  </OverlayTrigger>
                  :
                  <Button className="edit-icon" onClick={this.handleSave}>
                    Save
                  </Button>

                }
                <br/>
                <Button className="edit-icon" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </span>
              :
              <Fragment>
                {/* {currentUser && currentUser.is_manager ? */}
                  <span style={{float:"right"}}>
                    <Button className="edit-icon" onClick={this.toggleEditMode}>
                      Edit
                    </Button>
                  </span>
                  {/* : */}
                  {/* null */}
                {/* } */}
              </Fragment>
            }
          </div>
        </td>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps, { updatePublication })(PublicationOverviewField)



// WEBPACK FOOTER //
// ./src/routes/publications/components/PublicationOverviewField.js